module.exports = __webpack_public_path__ + "img/thumb1.a87bb1c6.png";